<template>
  <div class="scroll_flex_container">
    <navbar title="保管紀錄"></navbar>

    <!-- 分頁切換 -->
    <div class="deposit_tabs row_center_center">
      <div class="deposit_tab row_center_center"
           :class="{ active: activeTab === 'unclaimed' }"
           @click="switchTab('unclaimed')">未領取</div>
      <div class="deposit_tab row_center_center"
           :class="{ active: activeTab === 'claimed' }"
           @click="switchTab('claimed')">已領取</div>
    </div>

    <!-- 列表 -->
    <div class="deposit_list column_center_start">
      <template v-if="currentGroups.length">
        <div class="column_center_start w-full"
             v-for="(group, gIndex) in currentGroups" :key="gIndex">
          <div class="deposit_date_row row_center_start">
            <text class="deposit_date">{{ dateLabel }}{{ group.date }}</text>
          </div>
          <div class="deposit_row column_center_start"
               v-for="(row, rIndex) in group.rows" :key="rIndex">

            <!-- 套餐卡片 -->
            <div v-if="row.comboName" class="deposit_card deposit_combo_card column_start_start">
              <div class="deposit_combo_head row_center_between">
                <text class="deposit_name">{{ row.comboName }}</text>
                <div v-if="activeTab === 'unclaimed'" class="deposit_combo_head_right column_end_center">
                  <text class="deposit_combo_count">數量：{{ row.comboCount }}</text>
                </div>
              </div>
              <div class="deposit_divider"></div>
              <div class="deposit_sub_item row_center_between w-full"
                   v-for="(item, iIndex) in row.items" :key="iIndex">
                <div class="deposit_sub_left row_center_start">
                  <img v-if="imageUrl(item.productId)" class="deposit_sub_img"
                       :src="imageUrl(item.productId)" @error="onImgError" />
                  <div class="column_start_start"
                       :class="{ deposit_sub_text_with_img: imageUrl(item.productId) }">
                    <text class="deposit_sub_name">{{ item.name }}</text>
                    <text v-if="item.spec" class="deposit_sub_spec">規格：{{ item.spec }}</text>
                  </div>
                </div>
                <text class="deposit_sub_qty">x{{ item.count }}</text>
              </div>
              <div v-if="activeTab === 'claimed'" class="deposit_combo_footer row_center_end w-full">
                <text class="deposit_claimed_tag">已領取</text>
              </div>
            </div>

            <!-- 單品卡片 -->
            <div v-else class="deposit_card row_center_start">
              <img v-if="imageUrl(row.items[0].productId)" class="deposit_img"
                   :src="imageUrl(row.items[0].productId)" @error="onImgError" />
              <div class="deposit_info column_start_start"
                   :class="{ deposit_info_with_img: imageUrl(row.items[0].productId) }">
                <text class="deposit_name">{{ row.items[0].name }}</text>
                <text v-if="row.items[0].spec" class="deposit_spec">規格：{{ row.items[0].spec }}</text>
                <div class="deposit_qty_row row_center_between"
                     :class="{ deposit_qty_row_end: activeTab === 'unclaimed' }">
                  <text class="deposit_qty">數量：{{ row.items[0].count }}</text>
                  <text v-if="activeTab === 'claimed'" class="deposit_claimed_tag">已領取</text>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <div v-else-if="!loading" class="deposit_empty row_center_center">
        <text>{{ activeTab === 'claimed' ? '尚無領取紀錄' : '尚無保管商品' }}</text>
      </div>
    </div>
  </div>
</template>

<script>
import navbar from "@/components/general/navbar.vue";
import commonUtils from "@/utils/common.utils";
import auth from "@/utils/auth.utils";
import { mapState, mapGetters } from "vuex";

export default {
  components: { navbar },
  data() {
    return { activeTab: "unclaimed" };
  },
  computed: {
    ...mapState("basic", { currentStore: "currentStore" }),
    ...mapState("deposit", { loading: "loading", loaded: "loaded" }),
    ...mapGetters("userData", { isLogin: "isLogin" }),
    ...mapGetters("deposit", ["unclaimedGroups", "claimedGroups"]),
    currentGroups() {
      return this.activeTab === "claimed" ? this.claimedGroups : this.unclaimedGroups;
    },
    dateLabel() {
      return this.activeTab === "claimed" ? "領取日期：" : "";
    },
  },
  async mounted() {
    if (!this.isLogin) {
      commonUtils.createToast("warning", "登入狀態已過期，請重新登入");
      await commonUtils.delay(1500);
      auth.logout();
      this.$router.push({ path: `/${this.currentStore}` });
      return;
    }
    this.$store.commit("deposit/reset");
    await this.loadTab("unclaimed");
  },
  methods: {
    async switchTab(tab) {
      this.activeTab = tab;
      if (!this.loaded[tab]) await this.loadTab(tab);
    },
    async loadTab(tab) {
      try {
        commonUtils.createLoading("資料讀取中", "請稍後");
        const action = tab === "claimed" ? "deposit/fetchClaimed" : "deposit/fetchUnclaimed";
        await this.$store.dispatch(action);
        await this.loadImages();
        commonUtils.closeLoading();
      } catch (e) {
        commonUtils.closeLoading();
        commonUtils.createToast("warning", e);
      }
    },
    // 取兩個分頁全部 productId 的聯集抓圖（product 模組會整批覆寫 state，避免切回分頁圖片遺失）
    async loadImages() {
      try {
        const ids = [
          ...new Set(
            [...this.unclaimedGroups, ...this.claimedGroups]
              .flatMap((g) => g.rows.flatMap((r) => r.items.map((i) => i.productId)))
              .filter(Boolean)
          ),
        ];
        if (ids.length) await this.$store.dispatch("product/getProductImages", ids);
      } catch (e) {
        console.log("fetch deposit product images error", e);
      }
    },
    // 無圖回傳空字串：template 以 v-if 不顯示圖片，名稱／規格靠左
    imageUrl(productId) {
      return this.$store.getters["product/getProductImageById"](productId) || "";
    },
    onImgError(e) {
      e.target.style.display = "none";
    },
  },
};
</script>

<style lang="scss" scoped>
.deposit_tabs {
  width: 100%;
  height: 48px;
  flex-shrink: 0;
  background: #fff;

  .deposit_tab {
    flex: 1;
    height: 100%;
    font-size: 16px;
    color: #999;
    background: #fff;
    cursor: pointer;

    &.active {
      color: #fff;
      background: #FD5001;
      font-weight: 500;
    }
  }
}

.deposit_list {
  width: 100%;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 24px;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
}

.deposit_date_row {
  width: 92%;
  padding: 16px 4px 8px;
}
.deposit_date {
  font-size: 14px;
  color: #888;
}

.deposit_row {
  width: 92%;
  margin-bottom: 12px;
}

.deposit_card {
  width: 100%;
  background: #fff;
  border-radius: 8px;
  padding: 14px;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.08);
  align-items: flex-start;
}

.deposit_img {
  width: 72px;
  height: 72px;
  border-radius: 6px;
  object-fit: cover;
  background: #f0f0f0;
  flex-shrink: 0;
}

.deposit_info {
  flex: 1;
  min-width: 0;
}
.deposit_info_with_img {
  margin-left: 14px;
}

.deposit_name {
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;
  line-height: 1.4;
}
.deposit_spec {
  font-size: 14px;
  color: #888;
  margin-top: 6px;
}
.deposit_qty_row {
  width: 100%;
  margin-top: 10px;
}
.deposit_qty_row_end {
  justify-content: flex-end;

  .deposit_qty {
    font-size: 16px;
    font-weight: 500;
    color: #333;
  }
}
.deposit_qty {
  font-size: 14px;
  color: #555;
}
.deposit_claimed_tag {
  font-size: 13px;
  color: #FD5001;
  background: #FFEADF;
  padding: 3px 10px;
  border-radius: 4px;
}

/* 套餐卡片 */
.deposit_combo_head {
  align-items: center;
  /* 延伸到卡片左右及上緣，做成淡黃色標題列 */
  width: calc(100% + 28px);
  margin: -14px -14px 0;
  padding: 14px;
  background: #FFF8E1;
  border-radius: 8px 8px 0 0;
}
.deposit_combo_head_right {
  flex-shrink: 0;
  margin-left: 12px;
  row-gap: 4px;
}
.deposit_combo_count {
  font-size: 14px;
  color: #555;
}
.deposit_divider {
  width: 100%;
  height: 1px;
  background: #eee;
  margin: 0 0 4px;
}
.deposit_sub_item {
  padding: 8px 0;
}
.deposit_sub_left {
  flex: 1;
  min-width: 0;
}
.deposit_sub_img {
  width: 56px;
  height: 56px;
  border-radius: 6px;
  object-fit: cover;
  background: #f0f0f0;
  flex-shrink: 0;
}
.deposit_sub_text_with_img {
  margin-left: 12px;
  min-width: 0;
}
.deposit_sub_name {
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
  line-height: 1.4;
}
.deposit_sub_spec {
  font-size: 13px;
  color: #888;
  margin-top: 2px;
}
.deposit_sub_qty {
  font-size: 15px;
  color: #555;
  margin-left: 12px;
  flex-shrink: 0;
}
.deposit_combo_footer {
  margin-top: 10px;
}

.deposit_empty {
  width: 100%;
  padding: 60px 0;
  color: #999;
  font-size: 15px;
}
</style>
